var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMdiCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:camera"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25 25H43.75L56.25 12.5H93.75L106.25 25H125C128.315 25 131.495 26.317 133.839 28.6612C136.183 31.0054 137.5 34.1848 137.5 37.5V112.5C137.5 115.815 136.183 118.995 133.839 121.339C131.495 123.683 128.315 125 125 125H25C21.6848 125 18.5054 123.683 16.1612 121.339C13.817 118.995 12.5 115.815 12.5 112.5V37.5C12.5 34.1848 13.817 31.0054 16.1612 28.6612C18.5054 26.317 21.6848 25 25 25ZM75 43.75C66.712 43.75 58.7634 47.0424 52.9029 52.9029C47.0424 58.7634 43.75 66.712 43.75 75C43.75 83.288 47.0424 91.2366 52.9029 97.0971C58.7634 102.958 66.712 106.25 75 106.25C83.288 106.25 91.2366 102.958 97.0971 97.0971C102.958 91.2366 106.25 83.288 106.25 75C106.25 66.712 102.958 58.7634 97.0971 52.9029C91.2366 47.0424 83.288 43.75 75 43.75ZM75 56.25C79.9728 56.25 84.742 58.2254 88.2583 61.7417C91.7746 65.2581 93.75 70.0272 93.75 75C93.75 79.9728 91.7746 84.742 88.2583 88.2583C84.742 91.7746 79.9728 93.75 75 93.75C70.0272 93.75 65.2581 91.7746 61.7417 88.2583C58.2254 84.742 56.25 79.9728 56.25 75C56.25 70.0272 58.2254 65.2581 61.7417 61.7417C65.2581 58.2254 70.0272 56.25 75 56.25Z",
    fill: "#E1E1E1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiCamera);
export default __webpack_public_path__ + "static/media/mdi_camera.e7779f109e4b2f9128ba1c301374b288.svg";
export { ForwardRef as ReactComponent };